/**
 * Project Name: Brainsie eCommerce v4
 * Component: Featured Products Section (Dynamic)
 * Description: CMS wrapper for FeaturedProducts component using ProductsProvider
 * Author: Brainsie Team
 * Date Created: November 1, 2025
 */

import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import { useProducts } from "context/ProductsProvider";
import FeaturedProducts from "templates/default/views/Home/Sections/FeaturedProducts";

export default function FeaturedProductsSection({
  section,
  darkMode,
  theme,
  headerRefresh,
  setHeaderRefresh,
}) {
  const { getFeaturedProducts, loading } = useProducts();
  const [localHeaderRefresh, setLocalHeaderRefresh] = useState(true);

  // Parse section settings with fallbacks
  const sectionSettings = section.Section_Settings
    ? JSON.parse(section.Section_Settings)
    : {};

  // console.log("⭐ FEATURED PRODUCTS SECTION:", {
  //   sectionId: section.Section_Id,
  //   sectionCode: section.Section_Code,
  //   settings: sectionSettings,
  //   productsLoading: loading,
  // });

  // Enhanced settings with CMS control
  const settings = {
    // Layout settings
    paddingY: sectionSettings.paddingY || 3,
    paddingX: sectionSettings.paddingX || 0,
    maxWidth: sectionSettings.maxWidth || "xl",
    backgroundColor: sectionSettings.backgroundColor || "transparent",

    // Content settings - use section data headings
    showTitle: sectionSettings.showTitle !== false,
    customTitle: section.Section_Heading || sectionSettings.customTitle || "",
    customSubHeading:
      section.Section_Sub_Heading || sectionSettings.customSubHeading || "",
    customSubText:
      section.Section_Sub_Text || sectionSettings.customSubText || "",

    // Grid settings
    gridSpacing: sectionSettings.gridSpacing || 0.5,
    itemsPerRow: sectionSettings.itemsPerRow || {
      xs: 6,
      sm: 4,
      md: 3,
      lg: 2.4,
    },

    // Product filtering
    maxItems: sectionSettings.maxItems || undefined,
    sortBy: sectionSettings.sortBy || "Modified_On",
    sortOrder: sectionSettings.sortOrder || "desc",

    // Custom styles
    customStyles: sectionSettings.customStyles || {},
  };

  let products = getFeaturedProducts();

  // Apply additional filtering/sorting if configured
  if (settings.maxItems && products.length > settings.maxItems) {
    products = products.slice(0, settings.maxItems);
  }

  // console.log("⭐ Featured Products Count:", products.length);

  return (
    <Box
      component="section"
      className="featured-products-section"
      sx={{
        py: settings.paddingY,
        px: settings.paddingX,
        backgroundColor: settings.backgroundColor,
        ...settings.customStyles,
      }}
    >
      <Container maxWidth={settings.maxWidth}>
        <FeaturedProducts
          products={products}
          loading={loading}
          headerRefresh={headerRefresh || localHeaderRefresh}
          setHeaderRefresh={setHeaderRefresh || setLocalHeaderRefresh}
          sectionSettings={settings}
          darkMode={darkMode}
          theme={theme}
        />
      </Container>
    </Box>
  );
}
